import { render, staticRenderFns } from "./RequestRole.vue?vue&type=template&id=73c743ee"
import script from "./RequestRole.vue?vue&type=script&lang=js"
export * from "./RequestRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports